import React, {useEffect, useState} from 'react';
import PageWrapper from '../../../../../modules/PageWrapper';
import {useParams} from 'react-router-dom';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import {toast} from 'react-toastify';
import Header from './Header';
import Stream from './Stream';
import Settings from './Settings';
import Analyze from '../Analyze';

const Blogger = () => {
  const {id} = useParams();

  const [timeConfig, setTimeConfig] = useState({});
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);

  return (
    <PageWrapper
      prevTimeConfig={prevTimeConfig}
      allowAllTimes
      firstTimeConfig='current_month'
      breadcrumbs={[
        {title: 'Трекер', path: ``},
        {isSeparator: true},
        {title: 'Influence', path: ``},
        {isSeparator: true},
        {
          title: `Блогер #${id}`,
          path: `/`,
        },
      ]}
      title={`Блогер #${id}`}
    >
      <Component id={id} setPrevTimeConfig={setPrevTimeConfig} prevTimeConfig={prevTimeConfig} />
    </PageWrapper>
  );
};

const Component = ({
  isVerify,
  timeConfig,
  setPreloader,
  id,
  setPrevTimeConfig,
  prevTimeConfig,
  CalendarForFullScreen,
}) => {
  const store = useStore();
  const [page, setPage] = useState('stream');
  const [data, setData] = useState({});

  const [saveButtonState, setSaveButtonState] = useState(0);
  const [settingData, setSettingData] = useState({});
  const [settingValidation, setSettingValidation] = useState({});

  useEffect(() => {
    isVerify && getData();
  }, [timeConfig, isVerify]);

  const getData = async () => {
    const [getBlogger, getRomiList] = await Promise.all([
      store.requestGet(`traffics/influence/blogger/${id}`, {params: timeConfig}),
      store.requestGet('Finance/Category/getRomiList'),
    ]);

    const romi = Math.round(+getBlogger.romi);
    const indicator = getRomiList.find((el) => el.romi_min <= romi && el.romi_max >= romi);

    setData({...getBlogger, indicator});
    setSettingData({
      avatar: getBlogger?.avatar,
      instagram_link: getBlogger?.instagram_link,
      youtube_link: getBlogger?.youtube_link,
      name: getBlogger?.name,
      contact_email: getBlogger?.contact_email,
      contact_phone: getBlogger?.contact_phone,
      telegram_username: getBlogger?.telegram_username,
    });

    setPreloader(false);
  };

  const saveSetting = async () => {
    if (Object.values(settingValidation).some(Boolean)) return;

    const formData = new FormData();
    for (const [key, value] of Object.entries(settingData)) {
      if (key === 'avatar') {
        if (!!value.length) {
          formData.append(`${key}`, value[0]);
          continue;
        }
        continue;
      }
      formData.append(`${key}`, value || '');
    }

    const result = await store.requestPatch(
      `traffics/influence/blogger/${id}?token=${store?.user?.main_token}`,
      {
        data: formData,
        preloader: false,
      }
    );

    if (!!result) {
      setData((prev) => ({...prev, ...result}));
      toast.success(`Успешно обновлено!`, {});
    }

    !result &&
      toast.error(`Произошла ошибка в обновлении!`, {
        theme: 'colored',
      });
  };

  return (
    <>
      <Header
        page={page}
        setPage={setPage}
        data={data}
        id={id}
        settingData={settingData}
        setSettingData={setSettingData}
        saveSetting={saveSetting}
        saveButtonState={saveButtonState}
        setSaveButtonState={setSaveButtonState}
      />
      {page === 'stream' && (
        <Stream
          id={id}
          setPrevTimeConfig={setPrevTimeConfig}
          prevTimeConfig={prevTimeConfig}
          timeConfig={timeConfig}
          isVerify={isVerify}
          setPreloader={setPreloader}
          CalendarForFullScreen={CalendarForFullScreen}
        />
      )}
      {page === 'settings' && (
        <Settings
          setSettingData={setSettingData}
          settingData={settingData}
          settingValidation={settingValidation}
          setSettingValidation={setSettingValidation}
          saveButtonState={saveButtonState}
          setSaveButtonState={setSaveButtonState}
        />
      )}
      {page === 'analiz' && <Analyze id={id} tc={timeConfig} />}
    </>
  );
};

export default observer(Blogger);
